import type {FontSizeMappingHeuristicEntry} from './types'

export const FONT_SIZE_CLASSES_RULES: FontSizeMappingHeuristicEntry[] = [
    {
        minSourceFontSize: 0,
        maxSourceFontSize: 14
    },
    {
        minSourceFontSize: 15,
        maxSourceFontSize: 19,
        targetFontSize: 16
    },
    {
        minSourceFontSize: 20,
        maxSourceFontSize: 22,
        targetFontSize: 18
    },
    {
        minSourceFontSize: 23,
        maxSourceFontSize: 26,
        targetFontSize: 20
    },
    {
        minSourceFontSize: 27,
        maxSourceFontSize: 30,
        targetFontSize: 22
    },
    {
        minSourceFontSize: 31,
        maxSourceFontSize: 38,
        targetFontSize: 24
    },
    {
        minSourceFontSize: 39,
        maxSourceFontSize: 46,
        targetFontSize: 26
    },
    {
        minSourceFontSize: 47,
        maxSourceFontSize: 54,
        targetFontSize: 28
    },
    {
        minSourceFontSize: 55,
        maxSourceFontSize: 70,
        targetFontSize: 30
    },
    {
        minSourceFontSize: 71,
        maxSourceFontSize: 78,
        targetFontSize: 32
    },
    {
        minSourceFontSize: 79,
        maxSourceFontSize: 86,
        targetFontSize: 34
    },
    {
        minSourceFontSize: 87,
        maxSourceFontSize: 94,
        targetFontSize: 36
    },
    {
        minSourceFontSize: 95,
        maxSourceFontSize: 102,
        targetFontSize: 38
    },
    {
        minSourceFontSize: 103,
        scaleProportionally: true
    }
]

export const BUTTON_FONT_SIZE_CLASSES_RULES: FontSizeMappingHeuristicEntry[] = [
    {
        minSourceFontSize: 0,
        maxSourceFontSize: 14
    },
    {
        minSourceFontSize: 15,
        maxSourceFontSize: 19,
        targetFontSize: 16
    },
    {
        minSourceFontSize: 20,
        maxSourceFontSize: 22,
        targetFontSize: 18
    },
    {
        minSourceFontSize: 23,
        maxSourceFontSize: 26,
        targetFontSize: 20
    },
    {
        minSourceFontSize: 27,
        maxSourceFontSize: 30,
        targetFontSize: 22
    },
    {
        minSourceFontSize: 31,
        maxSourceFontSize: 38,
        targetFontSize: 24
    },
    {
        minSourceFontSize: 39,
        maxSourceFontSize: 46,
        targetFontSize: 26
    },
    {
        minSourceFontSize: 47,
        maxSourceFontSize: 54,
        targetFontSize: 28
    },
    {
        minSourceFontSize: 55,
        maxSourceFontSize: 70,
        targetFontSize: 30
    },
    {
        minSourceFontSize: 71,
        targetFontSize: 32
    }
]
